export default __webpack_public_path__ + "a69523ee08ed5919f13916a564b39b5e.jpg";